// extracted by mini-css-extract-plugin
export default {"comparisonTable":"comparison-table-module__comparisonTable__SGm55","contentTable":"comparison-table-module__contentTable__oh+cB"};